import { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import userService from "../../../services/user.service";
import backIcon from "../../../assets/images/public/back-icon.png";
import { ReactComponent as ContendZONE } from "../../../assets/images/contendZONEone.svg";
import { MessageAlert, Spinner } from "../..";
import { ForgotPasswordForm } from "./forgotPasswordForm";
import { emailAddress } from "../../../common";
import { connect } from "react-redux";
import { fullPageLoading } from "../../../Redux/Actions/LoadingActions";
class ForgotPass extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      errorMessage: "",
      visible: false,
    };
  }

  submitForget = ({ email }) => {
    const { history, fullPageLoading } = this.props;
    this.setErrorLoading("", true);
    fullPageLoading(true);
    userService
      .forgotPassword(email)
      .then((response) => {
        fullPageLoading(false);
        if (response.status === 200) {
          this.setErrorLoading("Link sent to your email id", false);
          this.handleClose(true);
          setTimeout(() => {
            history.push("/login");
          }, 3000);
        } else {
          this.setErrorLoading("Something went wrong", false);
        }
      })
      .catch(() => {
        fullPageLoading(false);
        this.setErrorLoading("Something went wrong", false);
      });
  };

  setErrorLoading = (errorMessage, loading) =>
    this.setState({
      errorMessage,
      loading,
    });

  handleClose = (visible) => this.setState({ visible });

  render() {
    const { errorMessage, visible, loading } = this.state;
    return (
      <div className="position-relative">
        <section className="guidlelines-section login-section position-relative">
          <div className="guidlelines-container contact-us-container position-relative">
            <Link>
              <ContendZONE id="mainlogo1" />
            </Link>
            <div className="contact-us-content signup-contnet">
              <div className="screen-title-container">
                <div className="screen-title-content">
                  <Link className="back-button-container" to="/">
                    <img src={backIcon} alt="back" />
                  </Link>
                </div>
              </div>
              <div className="faq-section">
                <div className="login-title">Forgot Password?</div>
                <div className="faq-section-tile-container pricing-section-tile-container contact-section-form-container">
                  <ForgotPasswordForm submitForget={this.submitForget} />
                </div>
              </div>
            </div>
            <div className="not-registered">
              Go Back to
              <Link className="forgot-link-container" to="/login">
                <div>Login</div>
              </Link>
              <Link className="forgot-link-container" to="/signup">
                <div>Sign Up</div>
              </Link>
            </div>
          </div>
          <div className="login-footer">
            <div>
              `Copyright © {new Date().getFullYear()} - All rights reserved |
              CONTENDZONE | Disclaimer | Privacy Policy`
            </div>
            <div>{emailAddress}</div>
          </div>
        </section>
        <MessageAlert
          message={errorMessage}
          handleClose={() => this.handleClose(false)}
          open={visible}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fullPageLoading: (obj) => fullPageLoading(dispatch, obj),
  };
};

const mapStateToProps = (state) => {
  return state;
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ForgotPass)
);
